<template>
  <div>
    <div
      v-if="showSelectAll"
      class="text-right"
      style="margin-top: -1.4rem"
    >
      <button
        class="btn btn-sm btn-outline-secondary"
        @click="selected = {}; update()"
      >
        <i class="fas fa-times mr-1" />
        {{ $t('shop.offer.clear') }}
      </button>
    </div>
    <div style="max-height: 400px; overflow: auto">
      <div>
        <GroupSelectList
          :group-options="groupOptions"
          :root-id="showSelectAll ? '' : '#all'"
          :selected="selected"
          :allow-rule-based-select="allowRuleBasedSelect"
          :inherited="showSelectAll ? {} : selectedInherited"
          @select="select"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import GroupSelectList from './GroupSelectList';

export default {
  props: {
    groupCodes: Array,
    showSelectAll: Boolean,
    allowRuleBasedSelect: Boolean,
    // Unselect parent groups flagged with removeWhenNoSubgroups once their last selected subgroup is unselected
    removeParentsWithoutSubgroups: Boolean,
  },
  data: () => ({
    selected: {},
    inherited: {},
  }),
  components: {
    GroupSelectList,
  },
  computed: {
    ...mapGetters(['groups']),
    groupOptions() {
      return (this.groups || [])
        .filter((x) => x.code !== '#all' || this.showSelectAll)
        .map((x) => (this.showSelectAll
          ? ({
            ...x,
            name: x.code === '#all' ? this.$t('company.all') : x.name,
            parentCode: x.code === '#all' ? '' : x.parentCode,
          })
          : x))
        .sort((a, b) => a.path.localeCompare(b.path));
    },
    selectedInherited() {
      return Object.values(this.inherited).flat().reduce((acc, curr) => {
        acc[curr] = true;
        return acc;
      }, {});
    },
  },
  methods: {
    select({ code, parents }) {
      const value = !this.selected[code];

      if (value) {
        this.$set(this.inherited, code, parents);
      } else {
        this.$delete(this.inherited, code);
      }

      this.$set(this.selected, code, value);

      if (!value && this.removeParentsWithoutSubgroups) {
        this.unselectParentsWithoutSubgroups(code);
      }

      this.update();
    },
    unselectParentsWithoutSubgroups(code) {
      const group = this.groups.find((x) => x.code === code);
      const parent = group && this.groups.find((x) => x.code === group.parentCode);

      if (!parent || !parent.removeWhenNoSubgroups || !this.selected[parent.code]) return;

      const hasSelectedSubgroup = Object.keys(this.selected)
        .some((x) => this.selected[x] && x.startsWith(`${parent.code}/`));

      if (hasSelectedSubgroup) return;

      this.$set(this.selected, parent.code, false);
      this.$delete(this.inherited, parent.code);
      this.unselectParentsWithoutSubgroups(parent.code);
    },
    toggleAll() {
      if (this.groupOptions.length === this.groupCodes.length) {
        this.selected = {};
      } else {
        this.groupOptions.forEach((x) => {
          this.$set(this.selected, x.code, true);
        });
      }
    },
    update() {
      const codes = Object.keys(this.selected).filter((x) => this.selected[x]);
      this.$emit('update:groupCodes', codes);
    },
  },
  created() {
    if (this.groupCodes && this.groupCodes.length > 0) {
      this.groupCodes.forEach((code) => {
        this.$set(this.selected, code, true);
      });
    }
  },
};
</script>

<style lang="scss" scoped>

</style>
